<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("menu.coupon") }}
                    </h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <!-- <div class="col-lg-6 col-5 text-right">
                    <base-button size="md" type="neutral" @click="handleCreate()">{{ $t("new") }}</base-button>
                </div> -->
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <template slot="header">
                        <div class="row">

                            <div class="col-md-2 col-xs-12">
                                <base-input class="">
                                    <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur"
                                        :config="{ allowInput: true }" :placeholder="$t('time_from')"
                                        class="form-control datepicker" v-model="params.time_from">
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2 col-xs-12">
                                <base-input>
                                    <flat-picker slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur"
                                        :config="{ allowInput: true }" :placeholder="$t('time_to')"
                                        class="form-control datepicker" v-model="params.time_to">
                                    </flat-picker>
                                </base-input>
                            </div>


                            <div class="col-auto">
                                <base-button size="md" @click="handleSearch()">
                                    <i class="fas fa-spinner fa-spin " v-if="isLoading"></i>
                                    {{ $t("search") }}</base-button>

                            </div>
                        </div>


                    </template>
                    <!-- end header -->

                    <div>
                        <el-table :data="queriedData" row-key="id" header-row-class-name="thead-light">
                            <!-- order_number -->
                            <el-table-column align="left" :label="$t('coupon_id')" min-width="80px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.id }} </span>

                                </div>
                            </el-table-column>

                            <!-- created_at -->
                            <el-table-column align="left" :label="$t('name')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.name }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('running_from')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.running_from }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" :label="$t('running_to')" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.running_to }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column align="left" label="ส่งแล้ว / ลงทะเบียนแล้ว / จำนวนลูกค้า" min-width="120px">
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.total_used }} / {{ row.total_register }} / {{ row.total_member }}  </span>
                                </div>
                            </el-table-column>




                            <el-table-column align="right" :label="$t('actions')" min-width="120px">
                                <div slot-scope="{ $index, row }" class="d-flex">

                                    <base-button
                                        @click.native="handleShowDetail(row)" class="edit" type="warning" size="sm"
                                        icon>
                                        <i class="text-dtac-bt fa fa-list"></i>
                                    </base-button>
                                    <!-- <base-button
                                        @click.native="handleShowMember(row)" class="edit" type="warning" size="sm"
                                        icon>
                                        <i class="text-dtac-bt fa fa-user-circle"></i>
                                    </base-button> -->
                                    <base-button
                                        @click.native="handleShowPrintModal(row)" class="edit" type="warning" size="sm"
                                        icon>
                                        <i class="text-dtac-bt fa fa-print"></i>
                                    </base-button>

                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0">
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="total">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>



        <modal
            :show.sync="showPrintModal"
            modal-classes="modal-secondary modal-lg"
        >
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">
                        สร้าง PDF
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input
                        :label="$t('running_from')"
                        v-model="running_from"
                    ></base-input>
                </div>
                <div class="col-md-6">
                    <base-input
                        :label="$t('running_to')"
                        v-model="running_to"
                    ></base-input>
                </div>
            </div>

			  <template slot="footer">
				<!-- Payment Check Success -->
				<button
                    type="button"
                    class="btn btn-md btn-link ml-auto btn-primary text-white"
                    @click="handleCreatePDF()"
                >
                    {{ $t("create") }}
                </button>
			  </template>

		</modal>



    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'
import FileInput from "@/components/Inputs/FileInput";
import { undistributeHeight } from '@fullcalendar/core';
import { read, utils, writeFile } from 'xlsx'

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableData: "Coupon/getData",
            isLoading: "Coupon/isLoading",

            isAdmin: "Auth/isAdmin",
            isOwner: "Auth/isOwner",
            isEmployee: "Auth/isEmployee",
            isAgent: "Auth/isAgent",
        }),



    },
    data() {
        return {
            propsToSearch: ["po_number", "partner_name", "user_full_name"],
            selectedRows: [],
            params: {
                time_from: "",
                time_to: "",
            },
            isExportLoading: false,
            showPrintModal: false,
            running_from: "",
            running_to: "",
            head: {},

        };
    },
    async mounted() {
        this.params.time_from = moment().subtract(40, 'days').format('YYYY-MM-DD');
        this.params.time_to = moment().format('YYYY-MM-DD');

        this.listData(this.params);

    },
    methods: {
        ...mapActions({
            listData: "Coupon/listData",
            createData: "Coupon/createData",
            updateData: "Coupon/updateData",
            deleteData: "Coupon/deleteData",
            getDetail: "Coupon/getDetail",
            getCouponDocument : "Coupon/getCouponDocument",

        }),

        handleSearch() {
            this.listData(this.params);
        },
        handleDetail(row) {
            // go to po page
            this.showDetailModal = true;
            this.orderDetail = row;
            console.log(this.orderDetail)
            this.listDatum({ id: row.ID });
            //
        },

        handleCreate() {
            this.$router.push("/backoffice/coupon/create");
        },
        handleShowPrintModal(row) {
            this.head = row
            this.showPrintModal = true;
        },
        handleShowDetail(row) {
            console.log(row)
            this.$router.push("/backoffice/coupon/detail/" + row.id);
        },
        handleShowMember(row){
            console.log("Show Member",row)
            this.$router.push("/backoffice/coupon/member/" + row.id);
        },
        handleCreatePDF(){
            // show wating modal

            // check running_from and running_to
            if(this.running_from == "" || this.running_to == ""){
                swal.fire({
                    title: "กรุณากรอกหมายเลขคูปอง",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            // to- from must be less than 10
            let fromInt = parseInt(this.running_from)
            let toInt = parseInt(this.running_to)
            if(toInt - fromInt > 15){
                swal.fire({
                    title: "กรุณากำหนดช่วงคูปองไม่เกิน 15 หมายเลข",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            // check running_from and running_to is valid


            swal.close();
            swal.fire({
                title: "กำลังดาวน์โหลด",
                text: "กรุณารอสักครู่",
                icon: "info",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });

            this.getCouponDocument({id:this.head.id,running_from: this.running_from, running_to: this.running_to}).then(resp => {
				// url = api path
				swal.close();
				let url = process.env.VUE_APP_API_BASE_URL + "/files/coupons/" + resp.data.Datum.url
				window.open(url, '_blank');
			}).catch(err => {
				swal.fire({
					title: err.response.data.Cause,
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			});
        }

    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
